/* Pure Desi — cart funnel tracking [FT-1] (30 Sep 2026, Abhi: "lets do 1 and 2").
   Question it answers: of the shoppers who open the bag page, how many set pickup or delivery, pick a date,
   tap checkout and confirm the Before-you-pay sheet, and where do the rest stop.
   Sends anonymous step events to pure-desi-funnel.pages.dev (Cloudflare D1). Kept: a random per-tab id, the step,
   bag mode, method, whether a date is set, in-app browser (ig/fb), phone/desktop, bag value in dollars and weight.
   Never sent: names, emails, addresses, the cart token, IP (not stored server side).
   Bird pre-fills 'Pick Up' before any tap, so a real choice is counted from taps on its tabs or stores ('tab', 'store').
   Read-only: Bird is never clicked or changed. Method and date come from the cart's own attributes via /cart.js
   (same rule as pd-qw.js); a store tap is noticed only, never acted on. Loaded on the cart template only.
   ES5, wrapped: if anything fails the page is exactly as it was. */
(function (w, d) {
  'use strict';
  try {
    if (!d.body || !d.body.classList.contains('template-cart') || !w.fetch) return;
    var URL_E = 'https://pure-desi-funnel.pages.dev/api/e';
    var cp = w.Shopify && w.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) return;
    var sid;
    try { sid = w.sessionStorage.getItem('pd-ft'); } catch (e) {}
    if (!sid) { sid = (Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).replace(/[^a-z0-9]/g, '').slice(0, 16); try { w.sessionStorage.setItem('pd-ft', sid); } catch (e) {} }
    var ua = navigator.userAgent || '';
    var inapp = /Instagram/i.test(ua) ? 'ig' : (/FBAN|FBAV|FB_IAB|FBIOS/i.test(ua) ? 'fb' : '');
    var dev = (w.innerWidth || 0) < 768 ? 'phone' : 'desk';
    var t0 = Date.now();
    var S = { method: '', has_date: false, bag: null, grams: null };
    function mode() { return d.body.getAttribute('data-pd-mode') || ''; }
    function send(e, extra, beacon) {
      var x = { e: e, sid: sid, mode: mode(), method: S.method, has_date: S.has_date ? 1 : 0, inapp: inapp, dev: dev,
                bag: S.bag, grams: S.grams, secs: Math.round((Date.now() - t0) / 1000) };
      if (extra) for (var k in extra) x[k] = extra[k];
      var body = JSON.stringify(x);
      try {
        if (beacon && navigator.sendBeacon) { navigator.sendBeacon(URL_E, new Blob([body], { type: 'text/plain' })); return; }
        w.fetch(URL_E, { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors', credentials: 'omit' }).catch(function () {});
      } catch (err) {}
    }
    function readCart() {
      return w.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c) return;
          var a = c.attributes || {};
          var has = function (k) { return !!(a[k] && String(a[k]).trim()); };
          var m = has('Delivery Method') ? String(a['Delivery Method']) : '';
          var dt = has('Delivery Date') && (m !== 'Pick Up' || has('Delivery Time'));
          S.bag = Math.round((c.items_subtotal_price || 0) / 100); S.grams = c.total_weight || 0;
          var first = !readCart.done; readCart.done = true;
          var mChanged = m !== S.method, dChanged = dt && !S.has_date;
          S.method = m; S.has_date = dt;
          if (first) { send('view'); return; }
          if (mChanged && m) send('method');
          if (dChanged) send('date');
        }).catch(function () {});
    }
    setTimeout(readCart, 1200);
    var poll = [];
    function soon() { poll.forEach(clearTimeout); poll = [1000, 3000, 6000].map(function (ms) { return setTimeout(readCart, ms); }); }
    d.addEventListener('pointerup', soon, { capture: true, passive: true });
    d.addEventListener('click', function (e) {
      var el = e.target; if (!el || !el.closest || !e.isTrusted) return;
      if (el.closest('#birdchime-slots-box .bird-location-item')) send('store');
      else if (el.closest('#birdchime-slots-box .bird-method-tab')) send('tab');
      else if (el.closest('#CheckOut')) send('co_tap');
      /* [R12-1] 5 Oct 2026: where in-app shoppers stall inside the date step (allowlisted in functions/api/e.js) */
      else if (el.closest('.bird-date-picker__input')) send('cal');
      else if (el.closest('.bird-date-grid__nav')) send('cal_nav');
      else if (el.closest('.bird-date-grid__cell')) send('cal_day');
      else if (el.closest('.bird-time-picker__input')) send('time_open');
      else if (el.closest('.bird-time-dropdown__option')) send('time_pick');
      else if (el.closest('.pdqw-app2__b, .pdqw-app__b')) send('app_copy');
      else if (el.closest('[data-pd-ck-yes]')) send('yes', null, true);
      else if (el.closest('[data-pd-ck-change]')) send('change');
    }, true);
    /* the Before-you-pay sheet (pd-diwali-mode.js) shows by dropping its hidden attribute */
    var sheetOn = false;
    function watchSheet() {
      var s = d.getElementById('pd-ckcheck'); if (!s || !w.MutationObserver) return;
      new w.MutationObserver(function () {
        var on = !s.hidden; if (on && !sheetOn) { readCart(); send('sheet'); } sheetOn = on;
      }).observe(s, { attributes: true, attributeFilter: ['hidden'] });
    }
    watchSheet();
    var left = false;
    function leave() { if (left) return; left = true; send('leave', null, true); }
    w.addEventListener('pagehide', leave);
    d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') leave(); else left = false; });
  } catch (err) {}
})(window, document);
